import { snakeCase } from 'lodash';
export var ResourceRequestEvents = /*#__PURE__*/ function(ResourceRequestEvents) {
    ResourceRequestEvents["ResourceRequestCreate"] = "resource_request_create";
    ResourceRequestEvents["ResourceRequestUpdate"] = "resource_request_update";
    ResourceRequestEvents["ResourceRequestDelete"] = "resource_request_delete";
    ResourceRequestEvents["ResourceRequestStatusUpdate"] = "resource_request_status_update";
    ResourceRequestEvents["ResourceRequestApprovalUpdate"] = "resource_request_approval_update";
    ResourceRequestEvents["ResourceRequestAssigneeUpdate"] = "resource_request_assignee_update";
    return ResourceRequestEvents;
}({});
export const ResourceRequestEventsMap = Object.keys(ResourceRequestEvents).reduce((acc, key)=>{
    acc[snakeCase(key).toUpperCase()] = ResourceRequestEvents[key];
    return acc;
}, {});
